import { GetAllPatientsRequestParams } from './patient';

export interface BatchDownloadCreateRequest {
  transmissiondata: {
    transmissionId?: number;
  }[];
}

export interface BatchDownloadCreateResponse {
  jobId: number;
  isSuccess: boolean;
  error?: {
    errorMsg: string;
  };
}

export interface BatchDownloadGetResponse {
  batchDownload: BatchDownload;
}

export interface BatchDownload {
  jobId: number;
  status: BatchJobStatus;
  message: string;
  s3SignedUrl: string;
  tranmissionCount: number;
  userId: string;
  createdAt: Date;
  updatedAt: Date;
}

export enum BatchJobStatus {
  INITIALIZED = 'initialized',
  PROCESSING = 'processing',
  SUCCESS = 'success',
  FAILED = 'failed'
}

export interface UpdateBatchDownloadPdfInfoRequest {
  tranmissionReportIds: number[];
  downloadDate: string;
}

export interface ExportAllBatchRequest extends GetAllPatientsRequestParams {
  isSelectedAll?: boolean;
}

export interface ExportAllBatchResponse {
  jobId: number;
  isSuccess: boolean;
  error?: {
    errorMsg: string;
  };
  transmissionIds: Array<number>;
}
